import { z } from 'zod';

// ERP Connection Param types for both backend and UI
export enum ParamType {
    String = 'String',
    Integer = 'Integer',
    Decimal = 'Decimal',
    Boolean = 'Boolean',
    Date = 'Date',
    Time = 'Time',
}

export interface ERPConnectionParam {
    Name: string;
    Label: string;
    Description?: string;
    Type: ParamType;
    Default: string;
    EnumOptions?: string;
    Required?: string;
    Value?: string | null;
}

// generic schema for ERPConnectionInfo parameters
export const ERPConnectionInfoParameterSchema = z
    .object({
        Name: z.string(),
        Label: z.string().nullish(),
        Description: z.string().nullish(),
        Type: z.nativeEnum(ParamType),
        Default: z.string().nullish(),
        EnumOptions: z.string().nullish(),
        Required: z.string().nullish(),
        Value: z.string().nullish(),
    })
    .superRefine((param, ctx) => {
        if (param.Required === 'True' && (!param.Value || param.Value.trim() === '')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `${param.Label || param.Name} is required.`,
                path: ['Value'],
            });
        }
    });

export const ERPConnectionInfoSchema = z.object({
    root: z.object({
        Parameters: z.object({
            Parameter: z.array(ERPConnectionInfoParameterSchema),
        }),
    }),
});

export type ERPConnectionInfoParameter = z.infer<typeof ERPConnectionInfoParameterSchema>;
export type ERPConnectionInfo = z.infer<typeof ERPConnectionInfoSchema>;

// TODO: make common generic type for XML fields?
export interface ERPXmlFieldStructure {
    root: Record<string, string>;
}
